module.exports = __webpack_public_path__ + "static/media/send.59e12c83.svg";